"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderListItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const utils_1 = require("../../../../utils");
const menu_1 = require("./menu");
exports.OrderListItem = (0, react_1.memo)(props => {
    const { order, provided, onEdit } = props;
    const { formatAddress } = (0, utils_1.useFormatAddress)();
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.Card, { onClick: () => onEdit(order), ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps, sx: { mb: 1 }, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Card.Header, { title: `#${order.id}` }), (0, jsx_runtime_1.jsx)(ui_kit_1.Card.Content, { children: (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "body2", color: "textSecondary", component: "div", children: order.address ? formatAddress(order.address) : "" }) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Card.Footer, { onClick: handleClick, children: (0, jsx_runtime_1.jsx)(menu_1.OrderActionMenu, { order: order }) })] }));
});
//# sourceMappingURL=index.js.map